export type ViewListenerState = 'mobile' | 'desktop'

export const getCurrentView = () =>
  window.innerWidth < 1024 ? 'mobile' : 'desktop'

export const initialViewListenerState = getCurrentView()
